const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

class Shrift {
  constructor (handler) {
    try {
      this.ws = new WebSocket('wss://api.evangelie.life/websocket')
      this.ws.onmessage = e => {
        this.messageLogger(e)
        handler(e)
      }
      this.ws.onerror = this.errorHandler
    } catch (error) {
      console.log(`[WS::CONNECTION_ERROR - ${Date.now()}]`, error.message)
    }
  }

  messageLogger = e => {
    // const response = JSON.parse(e.data)
    console.log(`[WS::MESSAGE - ${Date.now()}] ${e.data}`)
  }

  errorHandler = e => {
    console.log(`[WS::ERROR - ${Date.now()}] ${e.data}`)
    this.ws.close()
  }

  isConnected = async () => {
    if (this.ws.readyState === WebSocket.CLOSED) {
      return false
    } else if (this.ws.readyState === WebSocket.OPEN) {
      return true
    } else {
      await delay(200).then(this.isConnected)
    }
  }

  connect = async () => {
    await this.isConnected()
    return true
  }

  disconnect = () => {
    this.isConnected()
      .then(() => {
        this.ws.close()
      })
  }

  send = async data => {
    await this.connect()
    data['category'] = 'shrift'
    const message = JSON.stringify(data)
    try {
      this.ws.send(message)
    } catch (error) {
      console.log(`[WS::TRANSMISSION_ERROR - ${Date.now()}]`, error.message)
    }
  }
}

export default Shrift
